<template>
  <div class="page-section">
    <form id="form" action="#">

      <!-- .card -->
      <div class="card">
        <div class="d-xl-none">
          <button class="btn btn-danger btn-floated" type="button" data-toggle="sidebar">
            <em class="fa fa-th-list"></em>
          </button>
        </div><!-- .card -->

        <!-- .card-body -->
        <div class="card-body" id="personal">
          <fieldset>
            <legend>Personal Information</legend>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Staff ID</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-input type="text" class="form-control" :state="isEmpty(detail.staff_id)" v-model="detail.staff_id" :readonly="readonly" ></b-form-input>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Title</label>
              <div class="col-lg-8 col-xl-6">
                <v-select :options="options.title" v-model="detail.title" :disabled="readonly"></v-select>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Full Name</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-input type="text" class="form-control" :state="isEmpty(detail.full_name)" v-model="detail.full_name" :readonly="readonly"></b-form-input>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Initial/Nick Name</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-input type="text" class="form-control" :state="isEmpty(detail.nick_name)" v-model="detail.nick_name" :readonly="readonly"></b-form-input>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Place of Birth</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-input type="text" class="form-control" :state="isEmpty(detail.place_of_birth)" v-model="detail.place_of_birth" :readonly="readonly"></b-form-input>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Date of Birth</label>
              <div class="col-lg-8 col-xl-6">
                <flat-pickr v-model="detail.birthdate" :config="config" :disabled="readonly"></flat-pickr>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Gender</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-radio-group
                    v-model="detail.gender"
                    :options="options.gender"
                    plain
                    :state="isEmpty(detail.gender)"
                    button-variant="primary"
                    name="plain-inline-gender" :disabled="readonly"
                ></b-form-radio-group>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right">Nationality Status</label>
              <div class="col-lg-8 col-xl-6">
                <b-form-radio-group
                    v-model="detail.expatriat"
                    :options="options.expatriat"
                    plain
                    name="plain-inline-nationality"
                    :state="isEmpty(detail.gender)"
                    :disabled="readonly"
                ></b-form-radio-group>
              </div>
            </div>

            <hr class="mb-4">

            <div class="row mb-3">
              <label class="col-lg-3 text-lg-right"></label>
              <div class="col-lg-8 col-xl-6">
                <button class="btn btn-primary btn-block btn-save" type="button" v-show="!readonly">Update</button>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- /.card-body -->

      </div><!-- /.card -->
    </form>
  </div>
</template>

<script>
import vSelect from "vue-select"
import {BFormInput, BFormRadioGroup} from "bootstrap-vue"
import flatPickr from "vue-flatpickr-component"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "EmployeeBiodata",
  components:{
    vSelect,
    BFormInput,
    BFormRadioGroup,
    flatPickr
  },
  data(){
    return {
      readonly:true,
      detail :{
        staff_id: "",
        title:"",
        full_name:"",
        nick_name:"",
        place_of_birth:"",
        birthdate: "",
        gender:"",
        expatriat:""
      },
      options:{
        salutation:[{label:"Mr.", code:1}, {label:"Mrs.", code:2}, {label:"Ms.", code:3}],
        gender: [{text:"Female", value:"f"}, { text:"Male", value:"m"}],
        expatriat:[{text:"Expatriat", value:"expat"}, {text:"local", value:"local"}]
      },
      config: {
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    getDetailEmp(){

      AxiosCall.Get({},urlApi.employee.detail+"/"+this.$store.getters.userId).then(res=>{
        if (res.success){
          let data = res.atributes[0]
          this.detail.full_name = data.emp_name
          this.detail.staff_id = data.emp_number
          this.detail.title = data.title
          this.detail.nick_name = data.nick_name
          this.detail.place_of_birth = data.birth_place
          this.detail.birthdate = data.birth_date
          this.detail.gender = data.emp_gender
          this.detail.expatriat = data.emp_nationality
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
  },
  created() {
    this.getDetailEmp()
  }
}
</script>